// Web and mobile resolve the signed-in member's name here, never from a token (PII).
import { fetchUserInfo, memberNameFromStored, memberNameFromUserInfo, } from "@healthos/shared";
import { getWhoami } from "./api.js";
const NO_NAME = { fullName: null, firstName: null };
/** Keycloak /userinfo first, then the names stored on the users row (GET /api/me/whoami). */
export async function fetchMemberName(args) {
    const fromUserInfo = await fetchUserInfo({ endpoint: args.userInfoUrl, ...args })
        .then(memberNameFromUserInfo)
        .catch(() => null);
    if (fromUserInfo?.fullName || fromUserInfo?.firstName)
        return fromUserInfo;
    try {
        const whoami = await getWhoami(await args.client());
        return memberNameFromStored(whoami.firstName, whoami.lastName);
    }
    catch {
        return NO_NAME;
    }
}
//# sourceMappingURL=member-name.js.map